document.addEventListener("DOMContentLoaded", () => {

const isStandalone =
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone;

if (isStandalone) {
  document.body.classList.add("pwa-mode");
} else {
  return;
}

if (localStorage.getItem("welcomeSeen")) return;

 
  const overlay = document.createElement("div");

  overlay.innerHTML = `
    <div id="welcome-overlay" style="
      position:fixed;
      inset:0;
      background:#eef7ee;
      display:flex;
      justify-content:center;
      align-items:center;
      z-index:999999;
      opacity:0;
      transition:opacity .35s ease;
      font-family:Arial,sans-serif;
    ">
     <div style="text-align:center;max-width:500px;padding:30px;">

  <img
    id="welcome-logo"
    src="${window.CIH.logo}"
    alt="Core Immune Health"
    style="width:160px;height:auto;margin-bottom:30px;"
  >

  <h1 style="margin-bottom:20px;"><h1 style="
  margin-bottom:20px;
  font-size:36px;
  color:#2f7d32;
  font-weight:700;
">
    Welcome to Core Immune Health
  </h1>

  <p style="font-size:18px;line-height:1.6;margin-bottom:30px;">
    Thank you for installing our app.
  </p>

  <button id="welcome-close"
    style="
      margin-top:20px;
      padding:16px 42px;
font-size:18px;
font-weight:600;
color:white;
background:#2f7d32;
border:none;
border-radius:30px;
box-shadow:0 4px 12px rgba(47,125,50,0.25);
cursor:pointer;
transition:all .2s ease;
    ">
    Continue
  </button>

</div>
    </div>
  `;

  document.body.appendChild(overlay);
  requestAnimationFrame(() => {
  document.getElementById("welcome-overlay").style.opacity = "1";
});

  const button = document.getElementById("welcome-close");

button.addEventListener("mouseenter", () => {
  button.style.transform = "scale(1.04)";
});

button.addEventListener("mouseleave", () => {
  button.style.transform = "scale(1)";
});

 document
  .getElementById("welcome-close")
  .addEventListener("click", () => {

    localStorage.setItem("welcomeSeen", "true");

const button = document.getElementById("welcome-close");
button.disabled = true;

const welcome = document.getElementById("welcome-overlay");
welcome.style.opacity = "0";

    setTimeout(() => {
      overlay.remove();
    }, 350);

  });

});